import React from 'react';
import styled from 'styled-components';

import { green, exactWhite, black } from 'utils/style/colors';

interface ITabProps {
  width?: string;
  active: boolean;
}
export type TabItems = {
  [key: string]: { title: string; content: React.ReactNode };
};
interface ITabsProps {
  width?: string;
  activeTab: string | number;
  tabItems: TabItems;
  onChangeActiveTab: (activeTabKey: string | number) => void;
  wrapperStyle?: React.CSSProperties;
}

const TabsHeader = styled.div`
  display: flex;
`;

const Tab = styled('span')<ITabProps>`
  width: ${(props) => (props.width ? props.width : '100%')};
  color: ${(props) => (props.active ? green : black)};
  background-color: ${(props) => (props.active ? exactWhite : 'transparent')};
  flex: 1;
  padding: 0.5rem 1rem;
  display: flex;
  margin-top: 1rem;
  align-items: center;
  border-bottom: 1px dashed #c8cee0;
  justify-content: center;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  cursor: pointer;
  &:hover {
    color: ${green};
  }

  ${({ active }) =>
    active &&
    `
      border-bottom: none;
      border-top: 1px dashed #c8cee0;
      border-left: 1px dashed #c8cee0;
      border-right: 1px dashed #c8cee0;
  `}
`;

const TabsBody = styled.div`
  padding: 1rem;
  text-align: center;
  border-left: 1px dashed #c8cee0;
  border-right: 1px dashed #c8cee0;
  border-bottom: 1px dashed #c8cee0;
  border-radius: 10px;
  background-color: exactWhite;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
`;

class Tabs extends React.PureComponent<ITabsProps> {
  handleClickOnTab = (tabKey: string | number) => () => {
    this.props.onChangeActiveTab(tabKey);
  };

  render() {
    const { tabItems, activeTab, wrapperStyle } = this.props;
    return (
      <div style={wrapperStyle}>
        <TabsHeader>
          {Object.keys(tabItems).map((tabKey) => (
            <Tab
              key={tabKey}
              active={activeTab === tabKey}
              onClick={this.handleClickOnTab(tabKey)}
            >
              {tabItems[tabKey].title}
            </Tab>
          ))}
        </TabsHeader>
        <TabsBody>{tabItems[activeTab].content}</TabsBody>
      </div>
    );
  }
}

export default Tabs;
